import { gsap } from 'gsap';

export default class AccordionSegment {
	constructor(el) {
		// DOM elements
		this.el = el;
		this.button = el.querySelector('[data-accordion-button]');
		this.target = el.querySelector(this.button.dataset.accordionButton);

		if (!this.target) {
			return;
		}

		// Status
		this.isOpen = false;
		this.isAnimating = false;
		this.userToggled = false;
		this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		// Event listeners
		this.button.addEventListener('click', this.toggle.bind(this));
		this.events = [];
	}

	toggle() {
		if (this.isAnimating) {
			return;
		}

		this.userToggled = true;

		this.isOpen ? this.close() : this.open();
	}

	// Zonder animatie openen/sluiten, bijvoorbeeld voor een segment dat vanaf
	// een bepaald breakpoint standaard open staat.
	openInstant() {
		if (this.isOpen) {
			return;
		}

		gsap.killTweensOf(this.target);
		gsap.set(this.target, {
			display: 'block',
			height: 'auto',
			opacity: 1,
		});

		this.button.setAttribute('aria-expanded', true);
		this.isOpen = true;
		this.isAnimating = false;

		window.dispatchEvent(new CustomEvent('refresh-scroll'));
	}

	closeInstant() {
		if (!this.isOpen) {
			return;
		}

		gsap.killTweensOf(this.target);
		gsap.set(this.target, {
			display: 'none',
			height: 0,
			opacity: 0,
		});

		this.button.setAttribute('aria-expanded', false);
		this.isOpen = false;
		this.isAnimating = false;

		window.dispatchEvent(new CustomEvent('refresh-scroll'));
	}

	open() {
		if (this.isOpen) {
			return;
		}
		this.isAnimating = true;
		this.button.setAttribute('aria-expanded', true);

		return new Promise((resolve) => {
			const item = this.target;

			gsap.set(item, {
				opacity: 0,
				display: 'block',
			});

			const height = item.scrollHeight;

			const tl = gsap.timeline({
				onComplete: () => {
					gsap.set(item, {
						height: 'auto',
					});

					this.isOpen = true;
					this.isAnimating = false;

					window.dispatchEvent(new CustomEvent('refresh-scroll'));

					resolve();
				},
			});

			tl.to(item, {
				height: height,
				duration: this.prefersReducedMotion ? 0 : 0.5,
				ease: 'sine.inOut',
			});
			tl.to(item, {
				opacity: 1,
				duration: this.prefersReducedMotion ? 0 : 0.3,
				ease: 'none',
			});
		});
	}

	close() {
		if (!this.isOpen) {
			return;
		}
		this.isAnimating = true;
		this.button.setAttribute('aria-expanded', false);

		return new Promise((resolve) => {
			const item = this.target;

			gsap.set(item, {
				height: item.scrollHeight,
			});

			const tl = gsap.timeline({
				onComplete: () => {
					gsap.set(item, {
						height: 0,
						display: 'none',
					});

					this.isOpen = false;
					this.isAnimating = false;

					window.dispatchEvent(new CustomEvent('refresh-scroll'));

					resolve();
				},
			});

			tl.to(item, {
				opacity: 0,
				duration: this.prefersReducedMotion ? 0 : 0.3,
				ease: 'none',
			});
			tl.to(item, {
				height: 0,
				duration: this.prefersReducedMotion ? 0 : 0.5,
				ease: 'sine.inOut',
			});
		});
	}
}
